import React from 'react'

const Modal = ({ handleClose, props }) => {
	

	return (
<div className="modal">
<button onClick={handleClose}>Close</button>
</div>
			
		
	)
}

export default Modal 